import * as dateFnsCompat from 'utils/date-fns-compat';

import fp from "lodash/fp";
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { branch, compose, lifecycle, renderComponent, withProps } from 'recompose';
import { bindActionCreators } from 'redux';
import { dateFormats, routes } from '../../../../../constants';
import { getCpdCategory, getCpdHours } from '../../../../../services';
import { taskActions } from '../../../../../state/modules/task';
import { userTaskHistorySelector } from '../../../../../state/modules/task/selectors';
import { Icon, SortableTable } from '../../../../components';

const columns = [
  {
    name: 'name',
    display: () => 'Title',
    className: () => "name",
    sortable: true
  },
  {
    name: 'cpdCategory',
    display: () => 'CPD Category',
    className: () => "cpdCategory"
  },
  {
    name: 'cpdHours',
    display: () => 'CPD hours',
    className: () => "cpdHours"
  },
  {
    name: 'dueDate',
    display: () => 'Due Date',
    className: () => "dueDate",
    sortable: true
  },
  {
    name: 'viewTask',
    display: () => '',
    className: () => "viewTask"
  }
]

const UnpopulatedCompletedTasks = () => (
  <div className='profile--cpd-activity no-content'>
    <div className='inner'>
      <span>
        <Icon icon='cpd-activity-large' />
      </span>
      <h2>Task History</h2>
      <p>
        You haven’t completed any tasks yet. Your task history will appear once you have completed your first task.
      </p>
      <p className='buttons'>
        <LinkContainer to={routes.app.tasks.home}>
          <Button>
            Go to tasks <Icon icon='chevron-right-large' />
          </Button>
        </LinkContainer>
      </p>
    </div>
  </div>
);

const PopulatedCompletedTasks = ({
  rows,
  isFetching
}) => (
    <div className='profile--cpd-activity'>
      <div className='inner'>
        <h2>
          <Icon icon='cpd-activity-large' /> Task History
        </h2>
        <SortableTable
          className='table--task-history'
          isFetching={isFetching}
          unclickable={true}
          rows={rows}
          columns={columns} />
        <Row className='no-gutter row-slider'>
          <Col xs={12} md={4} mdOffset={4}>
            <LinkContainer
              className='full'
              to={routes.app.professionalProfile.completedTasks}>
              <Button>
                See all Task history <Icon icon='chevron-right-large' />
              </Button>
            </LinkContainer>
          </Col>
        </Row>
      </div>
    </div>
  );

export const formatRow = (allCpdCategorys, industryCpdCategory) => (task) => ({
  'name': task.name,
  'dueDate': dateFnsCompat.format(dateFnsCompat.parse(task.dueDate), dateFormats.ShortDate),
  'cpdCategory': getCpdCategory(task, allCpdCategorys, industryCpdCategory),
  'cpdHours': getCpdHours(task),
  'viewTask': <LinkContainer to={routes.app.tasks.view(task.id)}><Button bsStyle='plain'>View</Button></LinkContainer>
})

const mapStateToProps = (state) => ({
  history: userTaskHistorySelector(state),
  isFetching: state.task.isFetchingHistory,
  allCpdCategorys: state.cpdCategorys.cpdCategorys,
  industryCpdCategory: state.industry.cpdCategorys
})

const mapDispatchToProps = (dispatch) => ({
  getHistory: bindActionCreators(taskActions.task.getHistory, dispatch)
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.props.getHistory({ skip: 0, take: 6 });
    }
  }),
  branch(
    ({ history, isFetching, allCpdCategorys }) => isFetching || !history || !history.length || !allCpdCategorys,
    renderComponent(UnpopulatedCompletedTasks)
  ),
  withProps(
    ({ history, allCpdCategorys, industryCpdCategory }) => ({
      rows: fp.map(
        formatRow(allCpdCategorys, industryCpdCategory)
      )(history)
    })
  )
)(PopulatedCompletedTasks);



// WEBPACK FOOTER //
// ./src/containers/pages/app/professional-profile/partials/populated-completed-tasks.js